import React, {useState}from 'react';
import logo from "../images/logo.png";
import { Link } from "react-scroll";

function Navbar(){
    const [nav,setnav]=useState(false);
    const changeBackground=()=>{
        if (window.scrollY>=50){
            setnav(true);
        }else{
            setnav(false);
        }
    }
window.addEventListener('scroll',changeBackground);
  return (
    <div className={nav ?'nav active':'nav'}>
        <a href='#' className='logo'>
            <img src={logo} alt="logoimg"></img>
        </a>
        <input type="checkbox" className='menu-btn' id="menu-btn"/>
        <label className='menu-icon' for ='menu-btn'> 
        <span className="nav-icon"></span></label>

   <ul className="menu">

<li> <Link to="main" spy={true} smooth={true}>   Home </Link> </li>
<li> <Link to="about" spy={true} smooth={true}>   About </Link> </li>
<li> <Link to="feature" spy={true} smooth={true}>   Features </Link> </li>
<li> <Link to="presentation" spy={true} smooth={true}>  UI </Link> </li>
<li> <Link to="contact" spy={true} smooth={true}>   Contact</Link> </li>

</ul>
</div>

  )
}

export default  Navbar;